import styled from 'styled-components';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import { themeGet } from '@magalu/stereo-ui-styles';
const mobileStyle = {
  height: 'auto',
  fontSize: 0,
  flexWrap: 'no-wrap',
  mt: 0,
  overflow: 'auto',
  px: '9px',
  pb: '5px'
};
const desktopStyle = {
  height: '16px',
  fontSize: 1,
  flexWrap: 'wrap',
  mt: 1,
  overflow: 'hidden'
};
export const HeaderLinksContainer = styled(Flex).attrs(props => Object.assign({
  bg: 'background.primary'
}, props.isMobile ? Object.assign({}, mobileStyle) : Object.assign({}, desktopStyle), props))`
  white-space: pre;
  line-height: ${props => themeGet('lineHeights.plus')(props)}px;

  a {
    font-size: inherit;
  }
`;